
import NavbarLink from './NavbarLink';
import AdminLink from './AdminLink';

const DesktopNavigation = () => {
  return (
    <nav className="hidden md:flex items-center space-x-8 rtl:space-x-reverse">
      <NavbarLink to="/" text="الرئيسية" />
      <NavbarLink to="/oil-finder" text="البحث عن الزيت" />
      <NavbarLink to="/oil-request" text="أطلب زيت سيارتك" />
      <NavbarLink to="/booking" text="احجز موعدك" />
      <NavbarLink to="/shops" text="المحلات" />
      <AdminLink />
    </nav>
  );
};

export default DesktopNavigation;
